import React, { useMemo } from 'react';

import { Spinner } from '@/components/Spinner';
import { AccountGroupProfileWithAumIncluded } from 'views/portfolio/account-aum-queries';

import { useAssetClassExposure } from '../hooks/useAssetClassExposure';
import { AssetClassExposureChart } from './AssetClassExposureChart';

interface HouseholdAssetClassExposureCardProps {
    accountGroupProfiles: AccountGroupProfileWithAumIncluded[];
}

/** Asset class exposure rolled up across every account in the household. */
export const HouseholdAssetClassExposureCard = ({ accountGroupProfiles }: HouseholdAssetClassExposureCardProps) => {
    const accounts = useMemo(() => accountGroupProfiles.flatMap((profile) => profile.accounts), [accountGroupProfiles]);
    const { slices, totalExposure, isLoading, isError } = useAssetClassExposure(accounts);

    // Styled like the accounts table next to it: same border, and a header row matching its column headers.
    return (
        <section className="overflow-hidden rounded-lg border bg-white">
            <h3 className="flex h-12 items-center border-b px-4 text-sm font-medium text-gray-700">ASSET EXPOSURE</h3>
            <div className="p-4">
                {isLoading ? (
                    <div className="flex h-48 items-center justify-center">
                        <Spinner />
                    </div>
                ) : (
                    <AssetClassExposureChart slices={slices} totalExposure={totalExposure} isError={isError} />
                )}
            </div>
        </section>
    );
};
